import calc from 'calculatorjs'
import { addTimeAndTax, computeOtherFeeBeforeTimeAndTax } from './otherFee'

// ODD-001：PC 在 timeIns/tax 前扣券，H5 在之后；产品裁决前由 couponBeforeTimeAndTax 保留现状。
export function computeBizAmount (ctx, { couponBeforeTimeAndTax }) {
  const otherFeeBeforeTimeAndTax = computeOtherFeeBeforeTimeAndTax(ctx)
  let amount = calc(`${ctx.parcelsFee}+${otherFeeBeforeTimeAndTax}`)

  if (!couponBeforeTimeAndTax) {
    amount = addTimeAndTax(amount, ctx)
  }
  if (ctx.currCoupon) {
    amount = Math.max(calc.sub(amount, ctx.currCoupon.discountInfo.discount), 0)
  }
  if (ctx.finalSrParcelsFeeFormulas?.tempDiscountFees?.[4]) {
    amount = calc(`${amount} - ${ctx.finalSrParcelsFeeFormulas.tempDiscountFees[4]}`)
  }
  if (couponBeforeTimeAndTax) {
    amount = addTimeAndTax(amount, ctx)
  }
  if (ctx.cneeAddressDiscount) {
    amount = calc(`${amount} - ${ctx.cneeAddressDiscount[4]}`)
  }
  return amount
}
